import { Mail, MapPin } from "lucide-react";

export const contactInfo = [
  {
    icon: <Mail size={24} />,
    title: "Email Us",
    details: ["info@parsanagrochem.com"],
    color: "teal",
  },
  {
    icon: <MapPin size={24} />,
    title: "Location",
    details: [" Gujarat, India"],
    color: "indigo",
  },
];
